import VoucherInfo from './VoucherInfo';

export default VoucherInfo;
